<template>
  <div class="paypage">
    <div class="imgsty">
      <img src="@/assets/imgs/headerlogo.png" alt="" />
    </div>
    <div class="text_info">
      正在支付中({{ timemsg }})
      <div class="circle_box">
        <span class="circle"></span>
        <span class="circle"></span>
        <span class="circle"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      timemsg: 120,
    };
  },
  created() {
    this.showtimeMsg();
  },
  methods: {
    showtimeMsg() {
      let seitv = setInterval(() => {
        if (!this.timemsg) return clearInterval(seitv);
        this.timemsg = --this.timemsg;
      }, 1000);
    }
  },
};
</script>
<style  lang="scss" scoped>
.paypage {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: rgb(243, 243, 243);
  .imgsty {
    position: fixed;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }
  .text_info {
    position: absolute;
    font-size: 20px;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    color: rgb(112, 112, 112);
    text-align: center;
    .circle_box {
      text-align: center;
      .circle {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: rgb(112, 112, 112);
        animation-direction: alternate;
      }
      .circle:nth-of-type(2n) {
        margin: 0 10px;
      }
      .circle:nth-of-type(1) {
        animation: circlemove 3s linear infinite;
      }
      .circle:nth-of-type(2) {
        animation: circlemove 3s linear 0.5s infinite;
      }
      .circle:nth-of-type(3) {
        animation: circlemove 3s linear 1s infinite;
      }
      @keyframes circlemove {
        0% {
          transform: scale(0.8);
        }
        50% {
          transform: scale(1.5);
        }
        100% {
          transform: scale(1);
        }
      }
    }
  }
}
</style>